import React from "react";
import "./Footer.scss";
import { Image } from "react-bootstrap";

const Footer = () => {
  return (
    <footer id="footer">
      <Image
        src={process.env.REACT_APP_S3_IMAGE_PATH + "line.svg"}
        className="borderLine"
        fluid
      />
      <div className="wrapper">
        <p className="mb-0">
          Copyright © {new Date().getUTCFullYear()} Vanar Chain
        </p>
        <Image
          src={process.env.REACT_APP_S3_IMAGE_PATH + "logo.svg"}
          alt="virtua token"
          className="logo"
          fluid
        />
        <ul className="socials mb-0">
          <li>
            <a href={process.env.REACT_APP_TWITTER_URL} rel="noreferrer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.7431 9.01204L0 0.5H5.341L9.50346 5.76103L13.9504 0.523688H16.8919L10.9257 7.55865L18 16.5H12.675L8.16784 10.8105L3.35606 16.4843H0.398583L6.7431 9.01204ZM13.4511 14.9228L3.27493 2.07713H4.56424L14.7276 14.9228H13.4511Z"
                  fill="#909090"
                />
              </svg>
            </a>
          </li>
          <li>
            <a href={process.env.REACT_APP_TELEGRAM_URL} rel="noreferrer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.9593 16.3852L16.9599 16.3836L16.9775 16.3412L20 1.59794V1.55005C20 1.18271 19.8597 0.862027 19.5544 0.669671C19.2872 0.501301 18.98 0.48931 18.7647 0.505128C18.5369 0.521856 18.322 0.576869 18.1733 0.622662C18.0968 0.646221 18.0328 0.668921 17.987 0.68609C17.964 0.694707 17.9454 0.702019 17.9319 0.707467L17.9186 0.712886L1.06641 7.10877L1.06177 7.11038C1.05267 7.11359 1.04063 7.11793 1.0261 7.12341C0.997114 7.13432 0.957664 7.14994 0.91132 7.17026C0.820324 7.21016 0.694601 7.27173 0.567098 7.35621C0.350544 7.49968 -0.0618076 7.83935 0.00782129 8.37784C0.0654948 8.82388 0.383293 9.10716 0.597544 9.25383C0.712395 9.33245 0.822271 9.38914 0.902731 9.4262C0.943499 9.44498 0.978129 9.45936 1.00392 9.46952C1.01685 9.47462 1.02766 9.47869 1.03602 9.48176L1.04673 9.48563L1.05358 9.48809L4.00197 10.4484C3.99202 10.6274 4.01037 10.8099 4.05943 10.9899L5.53631 16.4101C5.71142 17.0528 6.31236 17.5005 6.99933 17.5C7.61509 17.4996 8.16121 17.1392 8.39322 16.6015L10.699 14.2162L14.6591 17.1535L14.7154 17.1773C15.0752 17.3292 15.4113 17.3773 15.7187 17.3367C16.0256 17.2962 16.2695 17.1716 16.4526 17.0298C16.6329 16.8903 16.7565 16.7328 16.8342 16.6142C16.8736 16.554 16.9031 16.5011 16.9235 16.4612C16.9337 16.4412 16.9418 16.4243 16.9479 16.4111L16.9555 16.3941L16.9582 16.3878L16.9593 16.3852ZM5.52131 10.617C5.48774 10.4939 5.54043 10.3638 5.65159 10.2955L15.6521 4.15124C15.6521 4.15124 16.2403 3.80575 16.2193 4.15124C16.2193 4.15124 16.3243 4.21225 16.0091 4.49673C15.7101 4.76691 8.88145 11.1454 8.19049 11.7908C8.1506 11.8281 8.1268 11.8708 8.11274 11.9227L6.99819 16.0373L5.52131 10.617Z"
                  fill="#909090"
                />
              </svg>
            </a>
          </li>
          <li>
            <a href={process.env.REACT_APP_MEDIUM_URL} rel="noreferrer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clipPath="url(#clip0_7883_2967)">
                  <path
                    d="M13.2871 11.9881C13.2871 15.4009 10.5393 18.1674 7.14986 18.1674C3.76046 18.1674 1.01245 15.4009 1.01245 11.9881C1.01245 8.57537 3.76025 5.80859 7.14986 5.80859C10.5395 5.80859 13.2871 8.57537 13.2871 11.9881Z"
                    fill="#909090"
                  />
                  <path
                    d="M20.0197 11.988C20.0197 15.2003 18.6458 17.8055 16.951 17.8055C15.2562 17.8055 13.8823 15.2003 13.8823 11.988C13.8823 8.77559 15.256 6.17041 16.9508 6.17041C18.6456 6.17041 20.0195 8.77475 20.0195 11.988"
                    fill="#909090"
                  />
                  <path
                    d="M22.7736 11.988C22.7736 14.8655 22.2904 17.1996 21.6943 17.1996C21.0982 17.1996 20.6152 14.8661 20.6152 11.988C20.6152 9.10985 21.0984 6.77637 21.6943 6.77637C22.2902 6.77637 22.7736 9.10964 22.7736 11.988Z"
                    fill="#909090"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7883_2967">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
